

<lib-modal 
[subtitle]="'COMPONENTS.MODAL_EXPIRATION.SUBTITLE' | translate: {id: personDataAsync()?.CallCode }"
[canCloseWithoutAction]="situation() !== eUserSituation.Blocked"
[show]="showModal()" [contentRef]="modalBody"></lib-modal>

<ng-template #modalBody>
  <div class="flex flex-col items-center gap-[20px] content-regular text-foreground">
    @let iconName = situation() === eUserSituation.Blocked ? 'lowBattery' : 'mediumBattery';

    <lib-system-icons [iconName]="iconName"></lib-system-icons>
    
    <p>{{'COMPONENTS.MODAL_EXPIRATION.HELLO' | translate: { name: personDataAsync()?.FirstName } }}</p>

    @if (situation() === eUserSituation.Blocked) {
      <ng-container [ngTemplateOutlet]="blocked"></ng-container>
    }

    <div class="flex flex-col items-center gap-[10px] max-w-[200px] w-full">
      <lib-button 
        class="w-full"
        id="billing-button" 
        (click)="viewBilling()"
        [type]="isHovering ? 'warning' : (situation() === eUserSituation.Blocked ? 'danger' : 'warning')"
        (mouseenter)="onBatteryHover()"
        (mouseleave)="onBatteryLeave()"> 
        {{'COMPONENTS.MODAL_EXPIRATION.SEE_BILL' | translate}}
      </lib-button>

      <lib-button
      (click)="signOut()"
      class="w-full"
      [type]="'secondary'"
      >
        {{'COMPONENTS.MODAL_EXPIRATION.LOGOUT' | translate}}
      </lib-button>
    </div>

    <p class="content-sm-regular text-muted-foreground">{{'COMPONENTS.MODAL_EXPIRATION.INFO' | translate}} <a class="text-link" href="">Chat</a></p>
  </div>
</ng-template>

<ng-template #blocked>
  <div class="flex flex-col items-center gap-[5px] content-regular text-foreground">
    <h3 class="content-bold">{{'COMPONENTS.MODAL_EXPIRATION.BLOCKED.TITLE' | translate}}</h3>
    <p>{{'COMPONENTS.MODAL_EXPIRATION.BLOCKED.DESCRIPTION' | translate}}</p>
  </div>
</ng-template>
